import tukeLogo from '.././images/tuke.gif';
import mailTuke from '.././images/mail1.gif';
import telephoneTuke from '.././images/telef1.gif';
import moodleTuke from '.././images/tuke_moodle_logo_na_web.png';

import Nav from 'react-bootstrap/Nav';


function LinkBar(){

    return(
        <div>
            <Nav defaultActiveKey="/home" as="ul" className="p-3 mb-2 bg-secondary text-white">
                <Nav.Item as="li">
                    <Nav.Link href='http://www.tuke.sk' target='_blank' className="text-black">
                        <img width="16" height="17" style={{ marginRight: "4px" }} src={tukeLogo} alt="Logo TUKE" />
                    </Nav.Link>
                </Nav.Item>

                <Nav.Item as="li">
                    <Nav.Link eventKey="link-1" href='http://www.fvt.tuke.sk' target='_blank'  className="text-black">
                        {/* <img width="30" height="17" border="0" style={{marginRight:"4px"}} src={fvtLogo}/>*/}
                        FVT
                    </Nav.Link>
                </Nav.Item>

                <Nav.Item as="li">
                    <Nav.Link eventKey="link-2" href='https://kpt.fvt.tuke.sk/' target='_blank' className="text-black">
                        KPT
                    </Nav.Link>
                </Nav.Item>

                <Nav.Item as="li">
                    <Nav.Link eventKey="link-3" href='http://mail.tuke.sk' target='_blank' className="text-black">
                        <img width="29" height="17" border="0" style={{marginRight:"4px"}} src={mailTuke} alt='Tuke mail'/>
                    </Nav.Link>
                </Nav.Item>

                <Nav.Item as="li">
                    <Nav.Link eventKey="link-4" href='https://mais.tuke.sk/index.php' target='_blank' className="text-black">
                        MAIS
                    </Nav.Link>
                </Nav.Item>

                <Nav.Item as="li">
                    <Nav.Link eventKey="link-5" href='https://zoznam.tuke.sk/?lang=SK' target='_blank' id="TUKE" className="text-black">
                        <img width="19" height="16" border="0" style={{marginRight:"4px"}} src={telephoneTuke} alt='telephone'/>
                    </Nav.Link>
                </Nav.Item>

                <Nav.Item as="li">
                    <Nav.Link eventKey="link-6" href='https://moodle.tuke.sk/moodle/' target='_blank' className="text-black">
                        <img width="100" height="17" border="0" style={{marginRight:"4px"}} src={moodleTuke} alt='moodle Tuke'/>
                    </Nav.Link>
                </Nav.Item>
            </Nav>

        </div>
    );
};

export default LinkBar;